"use strict";

class PropertySalesStatsController {

    constructor($timeout, Fullscreen, SSUserService, SSHttpService, SSAppService, SSAlertService) {
        const self = this;

        self.$timeout = $timeout;

        self.Fullscreen = Fullscreen;
        self.SSUserService = SSUserService;
        self.SSHttpService = SSHttpService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.data = SHOWSUITE.data;
        self.reports = {};
        self.sales_stages_units = [];
        // WEB-4837: units behind the clicked "Sold Units - By Sale Type" row
        self.sale_type_units = [];
        self.sale_type_units_type = {};
        self.nationalityReportGroupCount = {};

        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;
        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
        self.gst_inclusive = null;
        self.timeoutPromise = null;
    }

    init() {
        const self = this;

        self.getStats();
    }

    // API Calls
    //---------------------------------------------
    getStats() {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/launch-stats';
        if(self.gst_inclusive != null){
            url +='?gst_inclusive='+ self.gst_inclusive;
            if(self.timeoutPromise != null){
                self.$timeout.cancel(self.timeoutPromise);
            }
        }
        let params = {};

        self.loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.loading = false;

            if (response instanceof Error) {
                return;
            }

            if (response.data) {
                self.reports = self.parseResponse(response.data);
            }

            self.timeoutPromise = self.$timeout(function () {
                self.getStats();
            }, 10000); // 10 seconds

        });
    }

    getSalesGroupByStatusUnits(saleStatus) {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/sales-group-by-status-units/'+saleStatus;
        let params = {};
        self.sales_stages_units = [];

        loading(true);
        self.loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            self.loading = false;

            if (response instanceof Error) {
                return;
            }

            if (response.data) {
                self.sales_stages_units = response.data.sales_group_by_status_units;
                $('#SaleStatsUnitsModal').modal('show')
            }

        });
    }

    /**
     * WEB-4837: Load the units behind one row of the "Sold Units - By Sale Type"
     * card and show them in #SaleTypeUnitsModal. Loaded on click only; the counts
     * come with the polled launch-stats response.
     *
     * @remarks The API's bulk_type values (Bulk / Family Group) are shown under the
     * page's labels (Multiple Purchase / Group Purchase); any other value is shown as-is.
     *
     * @param {string} saleType single | bulk | bulk_multi_unit | family_group
     */
    getSaleTypeUnits(saleType) {
        const self = this;

        const labels = {
            single: 'SINGLE',
            bulk: 'BULK',
            bulk_multi_unit: 'MULTIPLE PURCHASE',
            family_group: 'GROUP PURCHASE',
        };
        const bulkTypeLabels = {
            'Bulk': 'Multiple Purchase',
            'Family Group': 'Group Purchase',
        };

        let url = 'sec/developer/properties/' + self.data.property.id + '/sale-type-units/' + saleType;
        let params = {};
        self.sale_type_units = [];
        self.sale_type_units_type = {key: saleType, label: labels[saleType] || saleType};

        loading(true);
        self.loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            self.loading = false;

            if (response instanceof Error) {
                return;
            }

            if (response.data) {
                self.sale_type_units = (response.data.sale_type_units || []).map(function (unit) {
                    unit.bulk_type_label = bulkTypeLabels[unit.bulk_type] || unit.bulk_type;
                    return unit;
                });
                $('#SaleTypeUnitsModal').modal('show')
            }

        });
    }

    parseResponse(data) {
        const self = this;

        // TOTALS
        data.totals = {
            units_group_by_status_sold: 0,
            units_group_by_status_total: 0,
            sales_group_by_status_total: 0,
            sales_group_by_unit_type_total: 0,
            sales_group_by_agency_total: 0,
            buyer_nationalities_report_total: 0,
        };

        $.each(data.units_group_by_status, function (i, item) {
            if (item.unit_status === 'RESERVED'
                || item.unit_status === 'BOOKED'
                || item.unit_status === 'SOLD'
            ) {
                data.totals.units_group_by_status_sold += item.count;
            }
            if (item.unit_status === 'LISTED'
                || item.unit_status === 'RESERVED'
                || item.unit_status === 'BOOKED'
                || item.unit_status === 'SOLD'
                || item.unit_status === 'SPECIAL RESERVED'
            ) {
                data.totals.units_group_by_status_total += item.count;
            }
        });

        $.each(data.sales_group_by_status, function (i, item) {
            if(item.sale_status !== "OTP ABORTED" && item.sale_status !== "REJECTED") {
                data.totals.sales_group_by_status_total += item.count;
            }
        });

        $.each(data.sales_group_by_agency, function (i, item) {
            data.totals.sales_group_by_agency_total += item.count;
        });

        if(data.sales_group_by_unit_type && data.sales_group_by_unit_type.length) {
            const saleGroupByUnitTypeReport = [];
            const saleGroupByUnitTypeReportGroupCount = {};
            data.sales_group_by_unit_type.sort((fItem, secItem) => fItem.category.localeCompare(secItem.category));
            $.each(data.sales_group_by_unit_type, function (i, item) {
                data.totals.sales_group_by_unit_type_total += item.count;

                const category = item.category;
                if (!saleGroupByUnitTypeReportGroupCount[category]) saleGroupByUnitTypeReportGroupCount[category] = {
                    count: 0,
                    total_count: 0
                };
                const count = saleGroupByUnitTypeReportGroupCount[category]['count'] || 0;

                const newObject = {
                    category: count === 0 ? category : null,
                    type: item.type,
                    count: item.count,
                    sub_cat_count: item.sub_cat_count
                };

                saleGroupByUnitTypeReport.push(newObject);
                saleGroupByUnitTypeReportGroupCount[category]['count'] = count + 1;
                saleGroupByUnitTypeReportGroupCount[category]['total_count'] += item.count;
                saleGroupByUnitTypeReportGroupCount[category]['main_cat_count'] = item.main_cat_count;
            });

            // WEB-3220 Calculate percentage after total count calculated
            $.each(data.sales_group_by_unit_type, function (i, item) {
                const category = item.category;
                saleGroupByUnitTypeReportGroupCount[category]['percentage'] =
                    self.calculatePercentage(
                        saleGroupByUnitTypeReportGroupCount[category]['total_count'],
                        saleGroupByUnitTypeReportGroupCount[category]['main_cat_count']);
            });

            self.saleGroupByUnitTypeReportGroupCount = saleGroupByUnitTypeReportGroupCount;
            data.sales_group_by_unit_type = saleGroupByUnitTypeReport;
        }

        if (data.buyer_nationalities_report && data.buyer_nationalities_report.length) {
            const nationalityReport = [];
            const nationalityReportGroupCount = {};

            data.buyer_nationalities_report.forEach(item => {
                data.totals.buyer_nationalities_report_total += item.count;
                const citizenship = item.citizenship.replace(/_/g, ' ');
                if(!nationalityReportGroupCount[citizenship]) nationalityReportGroupCount[citizenship] = { count: 0, total_count: 0 };
                const count = nationalityReportGroupCount[citizenship]['count'] || 0;

                const newObject = {
                    citizenship: count === 0 ? citizenship : null,
                    nationality: item.nationality,
                    count: item.count
                };

                nationalityReport.push(newObject);
                nationalityReportGroupCount[citizenship]['count'] = count + 1;
                nationalityReportGroupCount[citizenship]['total_count'] += item.count;
            });

            // WEB-3220 Calculate percentage after total count calculated
            data.buyer_nationalities_report.forEach(item => {
                const citizenship = item.citizenship.replace(/_/g, ' ');
                nationalityReportGroupCount[citizenship]['percentage'] =
                    self.calculatePercentage(
                        nationalityReportGroupCount[citizenship]['total_count'],
                        data.totals.buyer_nationalities_report_total);
            });

            self.nationalityReportGroupCount = nationalityReportGroupCount;
            data.buyer_nationalities_report = nationalityReport;
        }

        return data;
    }

    calculatePercentage(count, total) {
        if (!count || !total) { return 0; }
        const percentage = (count / total) * 100;
        return parseFloat(percentage.toFixed(2));
    }

    // Fullscreen
    toggleFullscreen($event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
        } else {
            if (!$event) return;

            if (typeof $event == "string") {
                self.Fullscreen.enable(document.getElementById($event));
            } else if ($event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable($event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable($event.currentTarget);
            }
        }
    }

    downloadEOIReportsStatsByType(type){
        const self = this;
        let url = 'sec/developer/properties/' + self.data.property.id + '/export-launch-stats/'+type;
        // WEB-3591: no api_token on the URL; getApiURL() returns a same-origin
        // proxy path and the token is attached server-side from the session.
        if(self.gst_inclusive != null){
            url +='?gst_inclusive='+ self.gst_inclusive;
        }
        let url_ping = window.open(self.SSHttpService.getApiURL(url),'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Report download completed successfully");
        }
    }

    // Helper Functions
    //----------------------------------------------
}

PropertySalesStatsController.$inject = ['$timeout', 'Fullscreen','SSUserService', 'SSHttpService', 'SSAppService', 'SSAlertService'];
app.controller('PropertySalesStatsController', PropertySalesStatsController);